import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
           light: {
               primary: "#436148",
               myGreen: "#688a6c",
               myWhite: "#fafafa",
               myBlue:"#1f5562",
               myOrange:"#a54e3b",
               myBrown:"#a4705a",
               myBCA:"#003399",
               myYellow: "#f0ab31"
           }
        }
    }
});
